<template>
    <ui-frame-bg class="select-list-box" colorType="blue-light" hook v-show="showSelect" v-if="list && list.length != 0">
        <ul class="select-list" :class="hook ? `hook-${hook}` : ''">
            <li 
                v-for="(item, key) in list" 
                :key="key" 
                :id="item.id"
                :class="{'active': subID === item.id}"
                @click="switchSource(item.id)"
            >
                <div class="label-box">
                    <span class="label-shadow">{{ item.name }}</span>
                    <span class="label-text">{{ item.name }}</span>
                </div>
            </li>
        </ul>
    </ui-frame-bg>
</template>

<script>
import UiFrameBg from '@/components/ui-frame-bg';
export default {
    components: {
        UiFrameBg
    },
    // inject: ['displaySelect'],
    props: {
        list: {
            type: Array,
            default: () => []
        },
        defaultID: {
            type: [String, Number],
            default: () => ''
        },
        displaySelect: {
            type: Function,
            default: () => false
        },
        showSelect: {
            type: Boolean,
            default: () => false
        },
        hook: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // subID: ''
            subID: this.defaultID != '' ? this.defaultID : ((this.list && this.list.length != 0) ? this.list[0].id : ''),
            // subID: this.defaultID != '' ? this.defaultID : ''
        }
    },
    watch: {
        list(newList) {
            if (newList && newList.length != 0) {
                this.subID = newList[0].id
            }
        }
    },
    mounted() {
        this.switchSource(this.subID)
    },
    methods: {
        switchSource(id) {
            this.displaySelect()
            this.subID = id
            this.$emit('handleSwitch', id)
        }
    }
}
</script>

<style lang="scss" scoped>
.select-list-box {
    height: auto;
}
.select-list {
    // width: get_vh(133px);
    // height: get_vh(170px);
    box-sizing: border-box;
    width: 100%;
    border-radius: get_vh(10px);
    padding: get_vh(8px) get_vh(15px);
    li {
        height: get_vh(37px);
        line-height: get_vh(37px);
        text-align: center;
        @include fontSet(20px);
        border-bottom: get_vh(2px) solid #275194;
        white-space: nowrap;

        &:last-child {
            border: none;
        }

        &.active {
            .label-box {
                .label-text {
                    color: #FEE000 !important;
                }
            }
        }
    }

    &.hook-px {
        border-radius: 10px;
        padding: 8px 15px;
        li {
            height: 37px;
            line-height: 37px;
            font-size: 20px;
            border-bottom: 2px solid #275194;

            &:last-child {
                border: none;
            }
        }
    }
}

@media screen and (max-aspect-ratio: 3/2) {
    .select-list {
        border-radius: get_vw(10px);
        padding: get_vw(8px) get_vw(15px);
        li {
            height: get_vw(37px);
            line-height: get_vw(37px);
            @include fontSet(20px);
            border-bottom: get_vw(2px) solid #275194;

            &:last-child {
                border: none;
            }
        }

        &.hook-px {
            border-radius: 10px;
            padding: 8px 15px;
            li {
                height: 37px;
                line-height: 37px;
                font-size: 20px;
                border-bottom: 2px solid #275194;

                &:last-child {
                    border: none;
                }
            }
        }
    }
}
</style>